import { Stack, Typography, Box, styled } from '@mui/material';

import { WITH_SAVED_QUERY_QUERY_PARAM } from '@AccessFlows/common/constants';
import { AccessFlowAppModelV2 } from '@api';
import TriggerTypeChip from '@common/ui/TriggerTypeChip';
import { LabeledTextField } from '@components';
import { DateTime } from '@utils';

import { AccessFlowCard } from './AccessFlowCard';
import { generatePath } from 'react-router-dom';
import { routes } from '@routes';

const AccessFlowSelectionListContainer = styled(Box)(({ theme }) => ({
  maxHeight: '400px',
  overflow: 'auto',
  marginLeft: `${theme.spacing(-2)} !important`,
  marginRight: `${theme.spacing(-2)} !important`,
  paddingLeft: `${theme.spacing(2)} !important`,
  paddingRight: `${theme.spacing(2)} !important`,
}));

interface AccessFlowSelectionListProps {
  accessFlows: AccessFlowAppModelV2[];
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedScopeId: string;
}

export function AccessFlowSelectionList({
  accessFlows,
  searchTerm,
  onSearchChange,
  selectedScopeId,
}: AccessFlowSelectionListProps) {
  return (
    <Stack direction="column" spacing={2}>
      <Stack direction="row" spacing={2} alignItems="flex-end" justifyContent="space-between">
        <Box sx={{ width: 320 }}>
          <LabeledTextField
            label="Search Access Flows"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </Box>
        <Typography variant="helperText" color="text.muted">
          {accessFlows.length} Access Flows
        </Typography>
      </Stack>
      {accessFlows.length === 0 && (
        <Typography variant="body2" color="text.muted">
          No Access Flows found
        </Typography>
      )}
      <AccessFlowSelectionListContainer>
        <Stack direction="column" spacing={2}>
          {accessFlows.map((flow) => (
            <AccessFlowCard
              key={flow.id}
              id={flow.id}
              title={flow.name}
              subtitle={`Created ${DateTime.fromUnix(Number(flow.created_date)).readable}`}
              selectButtonText="Use"
              icon={<TriggerTypeChip triggerType={flow.trigger_type} />}
              selectPath={`${generatePath(routes.EditAccessFlow.path, {
                id: flow.id,
              })}?${WITH_SAVED_QUERY_QUERY_PARAM}=${selectedScopeId}`}
              data-trigger="select_access_flow_clicked"
            />
          ))}
        </Stack>
      </AccessFlowSelectionListContainer>
    </Stack>
  );
}
